import _ from "underscore";
// import moment from "moment";

import { 
	SETUP_TOPIC_STATS, 
	SYNC_RELEVANCY, 
	SET_MAP_HIDDEN_BY_FILTERS,
	SET_FILTER_BY_MAP_COUNTRY,
} from "actions/constants.js";

import { 
	fetchArticles, 
	fetchEntities, 
	fetchMapData, 
	fetchPhrases, 
	fetchTimeseries
} from "actions/fetch";

import { 
	activateProposedFilters, 
	reactivateFilters, 
	getCountryFilters
} from "lib/helpers/filterHelpers.js";

import { mergeEntityFilters } from "@exo/helpers";
import { alignGraphDataTypeByPerspective, makeFetchKey } from "lib/helpers/helpers.js";

const CONTENT_PAGE_LENGTH = 50;

// updates the varStore
//		- allows projectConfig access to the initial store
// NOTE: Does not update any data
export function varStoreUpdate(parameters) {
	const { nar, perspective, currentZoom, activeFilters, mapHighlightId, contentFilteredByDate, entityFilters } = parameters;
	// narrative = object. Must have id & parent
	// activeFilters = array of any active filters or null
	// console.log(
	// 	"update varStore =>",
	// 	nar
	// 	// perspective,
	// 	// currentZoom,
	// 	// activeFilters,
	// 	// mapHighlightId,
	// 	// contentFilteredByDate
	// );

	return (dispatch) => {
		// prepare state
		dispatch({
			type: "varStoreUpdate", // ONLY updates varStore
			narrative: nar,
			perspective,
			activeFilters,
			currentZoom,
			entityFilters,
			mapHighlightId,
			contentFilteredByDate,
		});
	};
}

const checkMapHiddenByFilters = (hideMapFilters, activeFilters) => {
	let mapHidden = false;
	if (activeFilters) {
		const matchedTypes = {};
		for (let i=0; i<hideMapFilters.length; i++) {
			const hideMapFilter = hideMapFilters[i];
			matchedTypes[hideMapFilter.parent] = true;
			const matchedByTypeFilters = activeFilters.filter(x => {
				return x.parent === hideMapFilter.parent
			})
			if (matchedByTypeFilters.length > 0) {
				const idMatch = matchedByTypeFilters.find(x => { return x.id === hideMapFilter.id; });
				matchedTypes[hideMapFilter.parent] = matchedTypes[hideMapFilter.parent] && (!!idMatch);
			}
		}
		mapHidden = !Object.values(matchedTypes).every(
			value => value === true
		);
	}
	return mapHidden;
}

// one action to update all data for the Narratives tab
//		Updates Map, Graph, Article, and Entities data
// 		Works with 'all'
export function updateData(parameters) {
	const {
		activeFilters,
		contentFilteredByDate,
		currentFilters, // not required
		entityFilters,
		currentZoom,
		dontUpdateMap,
		keywords,
		mapHighlightId,
		nar,
		perspective,
		topicsPie,
		relevancyOverride,
	} = parameters;
	// // narrative = object. Must have id & parent
	// // activeFilters = array of any active filters or null
	// console.log(
	// 	"UD =>",
	// 	parameters
	// 	// 	// nar,
	// 	// 	// perspective,
	// 	// 	// currentZoom,
	// 	// 	// activeFilters,
	// 	// 	// mapHighlightId,
	// 	// 	// contentFilteredByDate,
	// 	// 	// dontUpdateMap,
	// 	// 	// entityFilters,
	// 	// 	// keywords
	// );
	const narrative = nar;

	return (dispatch, getState) => {
		const {
			graphDataTypes,
			hideMap,
			showAllTopicsMap,
			showTopicsInGraph,
			topPhrasesAvailable,
			topicStatsConfig,
			hideMapFilterIds,
		} = getState().projectConfig;

		const {
			articlesPageOffset,
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			dmaAggregation,
			graphDataTypeActive,
			translateEntities,
			filterByMapCountry,
			currentMapCountryFilter,
		} = getState().base;

		const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		const currentFiltersForReal = activateProposedFilters(currentFilters || reactivateFilters(baseFilters, activeFilters || []));
		const relevancy = relevancyOverride || getState().base.relevancy;

		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		const numberOfLinesWithParent = narrative.children && narrative.children.length > 0 ? narrative.children.length + 1 : 1;
		const numberOfLinesWithoutParent = narrative.children && narrative.children.length > 0 ? narrative.children.length : 1;
		// Show parent timeseries if showTopicsInGraph or there are no children
		// Also, dont' fetch the base object
		const showTopicLine = (showTopicsInGraph && narrative.parent !== "self") || !narrative.children || narrative.children.length < 1;
		const showMap = !hideMap && (showTopicLine || (showAllTopicsMap && narrative.parent === "self"));

		// const alignedDataType = alignGraphDataTypeByPerspective({ perspective, graphDataTypeActive, graphDataTypes });

		const fetchKey = makeFetchKey(narrative, perspective, activeFilters, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// prepare state
		dispatch({
			type: "updateVariables", // ONLY updates varStore
			perspective,
			activeFilters,
			currentZoom,
			entityFilters,
			mapHighlightId,
			contentFilteredByDate,
		});
		
		// Check if map should be hidden based on configured filters
		if (hideMapFilterIds && hideMapFilterIds.length > 0) {
			const hidden = checkMapHiddenByFilters(hideMapFilterIds, activeFilters);
			dispatch({
				type: SET_MAP_HIDDEN_BY_FILTERS,
				hidden
			});
		}

		// Check if map country filtering should be disabled based on country filter configuration
		if (filterByMapCountry) {
			const activeCountryFilters = getCountryFilters(activeFilters);
			let foundInvalidCountry = false;
			for (let i=0; i<activeCountryFilters.length; i++) {
				if (currentMapCountryFilter !== activeCountryFilters[i].id) {
					foundInvalidCountry = true;
					break;
				}
			}
			if (foundInvalidCountry || activeCountryFilters.length === 0) {
				dispatch({type: SET_FILTER_BY_MAP_COUNTRY, value: false});
			}
		}

		dispatch({
			type: "requestTimeseries",
			// Show children plus their parent, or one narrative
			numberOfLines: showTopicsInGraph && narrative.parent !== "self" ? numberOfLinesWithParent : numberOfLinesWithoutParent,
			narrative,
		});
		// dispatch({ type: "requestArticles" });

		const mergedFilters = mergeEntityFilters({
			activeFilters,
			entityFilters,
			keywords,
			perspective,
		});

		const startDate = contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin;
		const endDate = contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end;
		const params = {
			narrative,
			perspective,
			startDate,
			endDate,
			dataType: graphDataTypeActive,
			// dataType: alignedDataType,
			filtersList: mergedFilters || [],
			currentFilters: currentFiltersForReal,
			relevancy,
			stateCode: mapHighlightId,
			translateEntities,
			fetchKey,
		};

		const articleParams = params;
		articleParams.sortBy = contentHeaderSortType;
		articleParams.ascending = contentHeaderSortAscending;
		articleParams.pageLength = CONTENT_PAGE_LENGTH;
		articleParams.offset = articlesPageOffset;

		if (topicsPie && topicStatsConfig) {
			const allChildren = [];
			_.each(topicStatsConfig, (topic) => {
				_.each(topic.children, (child) => {
					allChildren.push(child);
				});
			});
			dispatch({ type: SETUP_TOPIC_STATS, topicStatsConfig, expectedNarratives: allChildren.length });
		}
		if (showTopicLine) {
			dispatch(fetchTimeseries(params));
		}
		_.each(narrative.children, (trend) => {
			dispatch(
				fetchTimeseries({
					narrative: trend,
					perspective,
					startDate,
					endDate,
					dataType: graphDataTypeActive,
					// dataType: alignedDataType,
					filtersList: mergedFilters || [],
					currentFilters: currentFiltersForReal,
					relevancy,
					fetchKey,
				})
			);
		});

		if (showMap) {
			// sets or clears mapHighlightId (which will load the map in highlight mode)
			if (!dontUpdateMap) {
				dispatch({ type: "setMapHighlightId", mapHighlightId });
			}

			params.dmaAggregation = dmaAggregation;
			dispatch(fetchMapData(params));
		}

		dispatch(fetchArticles(articleParams));
		if (topPhrasesAvailable) {
			dispatch(fetchPhrases(params));
		}
		// No entities in Reaction mode
		if (perspective !== "Audience") {
			dispatch({ type: "requestEntities" });
			dispatch(fetchEntities(params));
		}
		dispatch({
			type: SYNC_RELEVANCY,
			payload: { relevancy, activeRelevancy: relevancy },
		});
	};
}

// TODO: - add an update function to incorporate the initial data fetch, which may include updateMapData FLAG_REFACTOR_DATA_JS

// one action to update all data for the Map in the Narratives tab
//		Updates Map only
// 		Works with 'all'
export function updateMapData(parameters) {
	const {
		activeFilters,
		contentFilteredByDate,
		currentFiltersList,
		currentZoom,
		entityFilters,
		keywords,
		mapHighlightId,
		nar,
		perspective,
		updatedMapSegment,
	} = parameters;
	// // narrative = object. Must have id & parent
	// // activeFilters = array of any active filters or null
	// console.log(
	// 	"UMD =>",
	// 	parameters,
	// 	// 	// nar,
	// 	// 	// perspective,
	// 	// 	// currentZoom,
	// 	// 	// activeFilters,
	// 	mapHighlightId
	// 	// 	// contentFilteredByDate,
	// 	// 	// entityFilters,
	// 	// 	// keywords
	// );
	const narrative = nar;

	return (dispatch, getState) => {
		const { dmaAggregation, relevancy } = getState().base;

		const fetchKey = makeFetchKey(narrative, perspective, activeFilters, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// // prepare state
		// dispatch({
		// 	type: "updateVariables", // ONLY updates varStore
		// 	perspective,
		// 	activeFilters,
		// 	currentZoom,
		// 	entityFilters,
		// 	mapHighlightId,
		// 	contentFilteredByDate,
		// });

		const mergedFilters = mergeEntityFilters({
			activeFilters,
			entityFilters,
			keywords,
			perspective,
		});

		const startDate = contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin;
		const endDate = contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end;

		// TODO: See if this is needed
		// sets or clears mapHighlightId (which will load the map in highlight mode)
		// if (!dontUpdateMap) {
		// 	dispatch({ type: "setMapHighlightId", mapHighlightId });
		// }
		dispatch(
			fetchMapData({
				narrative,
				perspective,
				startDate,
				endDate,
				filtersList: mergedFilters || [],
				currentFilters: currentFiltersList,
				relevancy,
				stateCode: mapHighlightId,
				dmaAggregation,
				fetchKey,
				currentMapSegmentSpan: updatedMapSegment,
			})
		);
	};
}

export function updateCurrentMapData() {
	return (dispatch, getState) => {
		const {
			activeKeywords,
			activeNarrativeData,
			contentFilteredByDate,
			currentFiltersList,
			currentZoom,
			entityFilters,
			mapHighlightId,
			perspective,
			currentMapSegmentSpan,
		} = getState().base;
		
		return () => dispatch(
			updateMapData({
				activeFilters: currentFiltersList,
				contentFilteredByDate,
				currentFiltersList,
				currentZoom,
				entityFilters,
				keywords: activeKeywords,
				nar: activeNarrativeData,
				mapHighlightId,
				perspective,
				updatedMapSegment: currentMapSegmentSpan,
			})
		);
	}
}

// Only updates the graph data. Designed to support Graph's dataType feature
export function updateGraphData(parameters) {
	const { dataType } = parameters;

	return (dispatch, getState) => {
		const {
			activeKeywords,
			activeNarrativeData,
			contentFilteredByDate,
			currentFiltersList,
			currentZoom,
			entityFilters,
			perspective,
			relevancy,
		} = getState().base;
		const { showTopicsInGraph } = getState().projectConfig;
		const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		const currentFiltersForReal = activateProposedFilters(reactivateFilters(baseFilters, currentFiltersList));
		const narrative = activeNarrativeData;

		const numberOfLinesWithParent = narrative.children && narrative.children.length > 0 ? narrative.children.length + 1 : 1;
		const numberOfLinesWithoutParent = narrative.children && narrative.children.length > 0 ? narrative.children.length : 1;

		const fetchKey = makeFetchKey(narrative, perspective, makeFetchKey, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		dispatch({
			type: "requestTimeseries",
			// Show children plus their parent, or one narrative
			numberOfLines: showTopicsInGraph && narrative.parent !== "self" ? numberOfLinesWithParent : numberOfLinesWithoutParent,
			narrative,
		});
		// dispatch({ type: "requestArticles" });

		const mergedFilters = mergeEntityFilters({
			activeFilters: currentFiltersList,
			entityFilters,
			keywords: activeKeywords,
			perspective,
		});

		const startDate = contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin;
		const endDate = contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end;

		const params = {
			narrative,
			perspective,
			startDate,
			endDate,
			filtersList: mergedFilters || [],
			currentFilters: currentFiltersForReal,
			relevancy,
			fetchKey,
			dataType,
		};

		dispatch(fetchTimeseries(params));
		_.each(narrative.children, (trend) => {
			dispatch(
				fetchTimeseries({
					narrative: trend,
					perspective,
					startDate,
					endDate,
					filtersList: mergedFilters || [],
					currentFilters: currentFiltersForReal,
					relevancy,
					fetchKey,
					dataType,
				})
			);
		});
	};
}

// one action to update Articles and Entities for the Narratives tab
//		For use with zooming the graph
// 		Works with 'all'
export function updateLowerData(parameters) {
	const { 
		activeFilters, 
		contentFilteredByDate, 
		currentZoom, 
		entityFilters, 
		keywords, 
		mapHighlightId, 
		nar, 
		perspective,
		offset,
		pageLength,
	} = parameters;
	// narrative = object. Must have id & parent
	// activeFilters = array of any active filters or null
	// console.log(
	// 	"Update Lower Data =>",
	// 	nar,
	// 	perspective,
	// 	currentZoom,
	// 	activeFilters,
	// 	mapHighlightId,
	// 	contentFilteredByDate
	// );
	// console.log(
	// 	"Lower DATES:",
	// 	moment(currentZoom.begin).format("MMM D"),
	// 	moment(currentZoom.end).format("MMM D")
	// );

	const narrative = nar;

	return (dispatch, getState) => {
		const { translateEntities } = getState().base;
		const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		const currentFilters = activateProposedFilters(reactivateFilters(baseFilters, activeFilters || []));
		const {
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			relevancy,
		} = getState().base;
		const { topPhrasesAvailable } = getState().projectConfig;

		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		const fetchKey = makeFetchKey(narrative, perspective, activeFilters, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// prepare state
		dispatch({
			type: "updateLowerVariables", // ONLY updates varStore
			narrative,
			perspective,
			currentZoom,
			contentFilteredByDate,
		});

		// dispatch({ type: "requestArticles" });

		const mergedFilters = mergeEntityFilters({
			activeFilters,
			entityFilters,
			keywords,
			perspective,
		});

		const params = {
			narrative,
			perspective,
			startDate: contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin,
			endDate: contentFilteredByDate? Number(contentFilteredByDate.end)	: currentZoom.end,
			filtersList: mergedFilters || [],
			currentFilters,
			relevancy,
			translateEntities,
			fetchKey,
		};

		const articleParams = params;
		articleParams.sortBy = contentHeaderSortType;
		articleParams.ascending = contentHeaderSortAscending;
		articleParams.pageLength = pageLength !== undefined ? pageLength : CONTENT_PAGE_LENGTH;
		articleParams.offset = offset !== undefined ? offset : getState().base.articlesPageOffset;

		dispatch(fetchArticles(articleParams));
		if (topPhrasesAvailable) {
			dispatch(fetchPhrases(params));
		}
		// No entities in Reaction mode
		if (perspective !== "Audience") {
			dispatch({ type: "requestEntities" });
			dispatch(fetchEntities(params));
		}
	};
}

// one action to update Articles and Entities for the Narratives tab
//		For use with updateContentByDate. Stores the indicator (or clears it)
// 		Works with 'all'
export function updateDataByDate(parameters) {
	const { 
		activeFilters, 
		contentFilteredByDate, 
		currentZoom, 
		entityFilters, 
		keywords, 
		mapHighlightId, 
		nar, 
		perspective,
		offset,
		pageLength,
	} = parameters;
	// narrative = object. Must have id & parent
	// activeFilters = array of any active filters or null
	// console.log("Update Data by date =>", activeFilters, contentFilteredByDate);
	const narrative = nar;

	return (dispatch, getState) => {
		const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		const currentFilters = activateProposedFilters(reactivateFilters(baseFilters, activeFilters || []));
		const {
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			relevancy,
			translateEntities,
		} = getState().base;
		const { topPhrasesAvailable } = getState().projectConfig;

		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		const fetchKey = makeFetchKey(narrative, perspective, activeFilters, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// prepare state
		dispatch({
			type: "updateVariablesByDate", // ONLY updates varStore
			narrative,
			perspective,
			contentFilteredByDate,
		});

		// dispatch({ type: "requestArticles" });

		const mergedFilters = mergeEntityFilters({
			activeFilters,
			entityFilters,
			keywords,
			perspective,
		});

		const params = {
			narrative,
			perspective,
			startDate: contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin,
			endDate: contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end,
			filtersList: mergedFilters || [],
			currentFilters,
			relevancy,
			translateEntities,
			fetchKey,
		};

		const articleParams = params;
		articleParams.sortBy = contentHeaderSortType;
		articleParams.ascending = contentHeaderSortAscending;
		articleParams.pageLength = pageLength !== undefined ? pageLength : CONTENT_PAGE_LENGTH;
		articleParams.offset = offset !== undefined ? offset : getState().base.articlesPageOffset;

		dispatch(fetchArticles(articleParams));
		if (topPhrasesAvailable) {
			dispatch(fetchPhrases(params));
		}
		// No entities in Reaction mode
		if (perspective !== "Audience") {
			dispatch({ type: "requestEntities" });
			dispatch(fetchEntities(params));
		}
	};
}

// Updates the articles
//		For use with duplicate article toggle
// 		Works with 'all'
export function updateArticleData(parameters) {
	const { showDuplicates } = parameters;

	return (dispatch, getState) => {
		const { 
			activeKeywords, 
			contentFilteredByDate, 
			currentZoom, 
			entityFilters, 
			perspective,
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			relevancy,
		} = getState().base;
		const { varStore } = getState().storage;

		const activeFilters = varStore.narratives[perspective].filters;
		const narrative = getState().base.activeNarrativeData;
		const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		const currentFilters = activateProposedFilters(reactivateFilters(baseFilters, activeFilters || []));


		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		const fetchKey = makeFetchKey(narrative, perspective, currentFilters, currentZoom);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// prepare state
		// dispatch({ type: "requestArticles" });
		const mergedFilters = mergeEntityFilters({
			activeFilters,
			entityFilters,
			keywords: activeKeywords,
			perspective,
		});

		dispatch(
			fetchArticles({
				narrative,
				perspective,
				startDate: contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin,
				endDate: contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end,
				filtersList: mergedFilters || [],
				currentFilters,
				fetchKey,
				showDuplicates,
				sortBy: contentHeaderSortType,
				ascending: contentHeaderSortAscending,
				relevancy,
			})
		);
	};
}

// one action to update Entities for the Narratives tab
//		For use with the translate endities toggle
// 		Works with 'all'
export function updateEntityData({ translateEntities }) {
	// narrative = object. Must have id & parent
	// activeFilters = array of any active filters or null

	return (dispatch, getState) => {
		const {
			activeKeywords,
			activeNarrativeData,
			contentFilteredByDate,
			currentZoom,
			currentFiltersList,
			entityFilters,
			perspective,
			relevancy,
		} = getState().base;
		const narrative = activeNarrativeData;

		const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		const currentFilters = activateProposedFilters(reactivateFilters(baseFilters, currentFiltersList || []));

		const fetchKey = makeFetchKey(narrative, perspective, currentFiltersList, currentZoom, relevancy);
		dispatch({ type: "mostRecentFetch", fetchKey });

		// prepare state
		dispatch({
			type: "updateLowerVariables", // ONLY updates varStore
			narrative,
			perspective,
			currentZoom,
			contentFilteredByDate,
		});

		const mergedFilters = mergeEntityFilters({
			activeFilters: currentFiltersList,
			entityFilters,
			keywords: activeKeywords,
			perspective,
		});

		const params = {
			narrative,
			perspective,
			startDate: contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin,
			endDate: contentFilteredByDate ? Number(contentFilteredByDate.end) : currentZoom.end,
			filtersList: mergedFilters || [],
			currentFilters,
			relevancy,
			translateEntities,
			fetchKey,
		};

		// No entities in Reaction mode
		if (perspective !== "Audience") {
			dispatch({ type: "requestEntities" });
			dispatch(fetchEntities(params));
		}
	};
}
